/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable camelcase */
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import CircularProgress from '@material-ui/core/CircularProgress';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import React, { useState, useEffect } from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import moment from 'moment-timezone';

import PropTypes from 'prop-types';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';

// ----------------------------------------------------------------------

// 預設標籤
const defaultLabels = [
  "下車主動推播",
  "我要訂車",
  "上車主動推播",
  "訂單查詢",
  "車輛位置",
  "帳號綁定",
  "最新消息",
  "聯絡客服",
  "解除綁定",
  "搭車提醒推播"
];

// 預設數據
const defaultChartData = [
  {
    name: "各功能使用人次",
    type: "column",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    group: "statistics"
  },
  {
    name: "各功能使用人數",
    type: "line",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    group: "statistics"
  }
];

export default function AppWebsiteVisits() {
  // 基本設定
  const Region = localStorage.getItem('region');
  const host = localStorage.getItem('apiurl');

  // 狀態管理
  const [CHARTDATA, setCHARTDATA] = React.useState(defaultChartData);
  const [CHARTDATAlabel, setCHARTDATAlabel] = React.useState(defaultLabels);
  const [linebotStartDate, setLinebotStartDate] = React.useState(moment().tz('Asia/Taipei').add(-14, 'days'));
  const [linebotEndDate, setLinebotEndDate] = React.useState(moment().tz('Asia/Taipei'));
  const [focusedInput, setFocusedInput] = React.useState(null);
  const [isLoading, setisLoading] = React.useState(false);
  const [isInitialized, setIsInitialized] = React.useState(false);

  // 圖表配置
  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      group: 'statistics',
      animations: {
        enabled: false,  // 初始載入時關閉動畫
        dynamicAnimation: {
          enabled: true,  // 後續更新時啟用動畫
          speed: 350
        }
      }
    },
    stroke: { width: [3, 5] },
    plotOptions: {
      bar: { columnWidth: '30%', borderRadius: 4 },
      group: {
        groups: ['statistics']
      }
    },
    fill: { type: ['solid', 'solid'] },
    labels: CHARTDATAlabel,
    xaxis: { type: 'string' },
    yaxis: [{
      title: {
        text: '各功能使用人次',
      },
    }, {
      opposite: true,
      title: {
        text: '各功能使用人數'
      }
    }],
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} 人`;
          }
          return y;
        }
      }
    }
  });

  // 讀取line服務統計
  const gps_lineservice = async () => {
    setisLoading(true);
    const formattedLinebotStartDate = linebotStartDate.format('YYYY-MM-DD');
    const formattedLinebotEndDate = linebotEndDate.format('YYYY-MM-DD');

    try {
      const response = await axios.get(`${host}/api/analyze/getline_service_statistics?Region=${Region}&start=${formattedLinebotStartDate}&end=${formattedLinebotEndDate}`);

      if (response.data.code === 0 && response.data.data) {
        const linetimes = response.data.data.linetimes || {};
        const people = response.data.data.people || {};

        // 使用預設標籤作為基礎
        const labels = Object.keys(linetimes);
        if (labels.length > 0) {
          setCHARTDATAlabel(labels);
        }

        if (labels.length === 0) {
          setCHARTDATA(defaultChartData);
          return;
        }

        const lineservice_statistics = [
          {
            name: '各功能使用人次',
            type: 'column',
            data: Object.values(linetimes).map(value => value || 0),
            group: 'statistics'
          },
          {
            name: '各功能使用人數',
            type: 'line',
            data: Object.values(people).map(value => value || 0),
            group: 'statistics'
          }
        ];

        setCHARTDATA(lineservice_statistics);
      } else {
        // 使用預設值
        setCHARTDATAlabel(defaultLabels);
        setCHARTDATA(defaultChartData);
      }
    } catch (error) {
      console.log('數據獲取錯誤:', error);
      // 發生錯誤時使用預設值
      setCHARTDATAlabel(defaultLabels);
      setCHARTDATA(defaultChartData);
    } finally {
      setisLoading(false);
    }
  };

  // 初始化和定時更新
  useEffect(() => {
    const initializeChart = async () => {
      setisLoading(true);
      try {
        await gps_lineservice();
      } catch (error) {
        console.error('初始化錯誤:', error);
      } finally {
        setIsInitialized(true);
        setisLoading(false);
      }
    };

    // 首次載入時初始化
    if (!isInitialized) {
      initializeChart();
    }

    // 設置定時更新
    const intervalId = setInterval(() => {
      if (isInitialized) {
        gps_lineservice();
      }
    }, 30000);

    // 清理函數
    return () => {
      clearInterval(intervalId);
    };
  }, [linebotEndDate, linebotStartDate, isInitialized]);

  // 查詢按鈕點擊事件
  const handleLINEateventClick = () => {
    gps_lineservice();
  };

  return (
    <Card>
      <CardHeader title="LINE@服務統計" />
      <Grid container alignItems="center">
        <Grid item xs={10}>
          <Box display="flex" alignItems="center">
            <Typography variant="body1">查詢區間：</Typography>
            <DateRangePicker
              startDate={linebotStartDate}
              startDateId="your_unique_start_date_id"
              endDate={linebotEndDate}
              endDateId="your_unique_end_date_id"
              onDatesChange={({ startDate, endDate }) => {
                setLinebotStartDate(startDate);
                setLinebotEndDate(endDate);
              }}
              focusedInput={focusedInput}
              onFocusChange={focusedInput => setFocusedInput(focusedInput)}
              isOutsideRange={() => false}
              numberOfMonths={1}
            />
          </Box>
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLINEateventClick}
            disabled={!isInitialized || isLoading}
          >
            查詢
          </Button>
        </Grid>
      </Grid>
      <Box position="relative" sx={{ minHeight: '360px' }}>
        {isLoading && (
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgcolor="rgba(0, 0, 0, 0.5)"
            display="flex"
            justifyContent="center"
            alignItems="center"
            zIndex={1}
          >
            <CircularProgress />
            <Typography variant="h6" color="textPrimary" style={{ color: '#fff', marginLeft: '10px' }}>
              載入中...
            </Typography>
          </Box>
        )}
        <ReactApexChart
          type="line"
          series={CHARTDATA}
          options={chartOptions}
          height={360}
        />
      </Box>
    </Card>
  );
}